import {
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT,
  QUIZ_ORDER,
  QUIZ_ORDER_ITEM
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { shuffle } from '~/lib/shuffle';

export const Quiz14: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              type: LAYOUT_COLUMNS,
              id: item.id,
              values: {},
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: { align: 'left' },
                  items: [
                    {
                      type: TEXT,
                      id: `${item.id}_subtitle`,
                      items: [],
                      values: {
                        value: item.subtitle,
                        variant: 'sub_heading',
                        icon: item?.icon || ''
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_title`,
                      items: [],
                      values: {
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_body`,
                      items: [],
                      values: {
                        value: item.body
                      }
                    },
                    {
                      type: QUIZ_ORDER,
                      id: `${item.id}-quiz-order`,
                      values: {
                        variant:
                          item.items && item.items.length > 2 ? 'list' : '',
                        correctAnswers: item.items
                          ? item.items.map(i => i.id)
                          : []
                      },
                      items: shuffle(
                        (item.items || []).map((i, index) => {
                          return {
                            type: QUIZ_ORDER_ITEM,
                            id: i.id,
                            values: {
                              id: i.id,
                              maxIndex: item.items?.length,
                              initialIndex: index,
                              text: i.value,
                              state: 'default'
                            }
                          };
                        })
                      )
                    }
                  ]
                } as LayoutListDefinition
              ]
            }
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });
};
